import React from 'react'
import ENSLogo from '../components/HomePage/images/ace_domains.svg'
import styled from '@emotion/styled/macro'
import { motion } from 'framer-motion'
import mq from 'mediaQuery'
import { launchInfo } from '../constants/launchInfo'
import CountDownTimer from '../components/Launch/CountDownTimer'
// import CookieConsent from "react-cookie-consent";


const LogoLarge = styled(motion.img)`
  width: 50%;
  margin: 0 auto 0;
  ${mq.medium`
    width: 600px;
  `}
`

const animation = {
  initial: {
    scale: 0,
    opacity: 0
  },
  animate: {
    opacity: 1,
    scale: 1
  }
}

const SoonComponent = () => {
  return (
    <div style={{width:"100%", height: "100vh", display: "flex", flexDirection: "column", justifyContent:"center", alignContent:"center", alignItems:"center", color: "white"}}>
      <LogoLarge
        initial={animation.initial}
        animate={animation.animate}
        src={ENSLogo}
      />
      <div style={{display: "flex", flexDirection:"column", justifyContent:"center", alignItems: "center", width:"100%"}}>
        <h1>Get Ready...</h1>
        <div>
          <CountDownTimer/>
        </div>
      </div>
      {/*<CookieConsent>This site uses cookies.</CookieConsent>*/}
    </div>
  )
}

export default SoonComponent
